import { BreakpointsRoot } from "theme/types/base/breakpoints";

const breakpoints: BreakpointsRoot = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
    xxxl: 1700,
  },
};

export default breakpoints;
